module.exports = __webpack_public_path__ + "static/media/inside2.102af74a.jpg";